(function() {
  'use strict';

  // ES5 compatible custom element
  var CartDiscountComponent = function() {
    // Call HTMLElement constructor
    return Reflect.construct(HTMLElement, [], CartDiscountComponent);
  };

  // Set up prototype chain
  CartDiscountComponent.prototype = Object.create(HTMLElement.prototype);
  CartDiscountComponent.prototype.constructor = CartDiscountComponent;
    
  CartDiscountComponent.prototype.connectedCallback = function() {
    this.requiredRefs = ['cartDiscountError', 'cartDiscountErrorDiscountCode', 'cartDiscountErrorShipping'];
    this.activeFetch = null;
    this.setupRefs();
    this.bindEvents();
  };

  CartDiscountComponent.prototype.setupRefs = function() {
    // Setup refs for error elements
    this.refs = {}; // Initialize refs object
    this.refs.cartDiscountError = this.querySelector('.cart-discount__error');
    this.refs.cartDiscountErrorDiscountCode = this.querySelector('[ref="cartDiscountErrorDiscountCode"]');
    this.refs.cartDiscountErrorShipping = this.querySelector('[ref="cartDiscountErrorShipping"]');
    
    // If refs not found, try alternative selectors
    if (!this.refs.cartDiscountErrorDiscountCode) {
      var errorTexts = this.querySelectorAll('.cart-discount__error-text');
      this.refs.cartDiscountErrorDiscountCode = errorTexts[0];
      this.refs.cartDiscountErrorShipping = errorTexts[1] || errorTexts[0];
    }
  };

  CartDiscountComponent.prototype.bindEvents = function() {
    var self = this;
    var form = this.querySelector('.cart-discount__form');
    
    if (form) {
      form.addEventListener('submit', function(e) {
        self.applyDiscount(e);
      });
    }

    // Bind remove discount events
    this.bindRemoveEvents();
  };

  CartDiscountComponent.prototype.bindRemoveEvents = function() {
    var self = this;
    var removeButtons = this.querySelectorAll('.cart-discount__pill-remove');
    
    for (var i = 0; i < removeButtons.length; i++) {
      removeButtons[i].addEventListener('click', function(e) {
        self.removeDiscount(e);
      });
    }
  };

  CartDiscountComponent.prototype.createAbortController = function() {
    if (this.activeFetch) {
      this.activeFetch.abort();
    }

    var abortController = new AbortController();
    this.activeFetch = abortController;
    return abortController;
  };

  CartDiscountComponent.prototype.getCartUpdateUrl = function() {
    // Use the correct cart update endpoint
    return '/cart/update.js';
  };

  CartDiscountComponent.prototype.applyDiscount = function(event) {
    var self = this;
    
    event.preventDefault();
    event.stopPropagation();

    var form = event.target;
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    var discountCode = form.querySelector('input[name="discount"]');
    if (!(discountCode instanceof HTMLInputElement) || typeof this.dataset.sectionId !== 'string') {
      return;
    }

    var discountCodeValue = discountCode.value.trim();
    
    // Check if discount code is empty
    if (!discountCodeValue) {
      return;
    }

    var abortController = this.createAbortController();

    var existingDiscounts = this.existingDiscounts();
    if (existingDiscounts.indexOf(discountCodeValue) !== -1) {
      // Discount already applied
      discountCode.value = '';
      return;
    }

    // Hide all error messages
    this.hideAllErrors();

    var cartUpdateUrl = this.getCartUpdateUrl();

    // Apply discount while keeping existing discounts
    var discountData = {
      discount: existingDiscounts.concat([discountCodeValue]).join(',')
    };

    fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(discountData),
      signal: abortController.signal
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(function(data) {
      // Check if discount code is invalid using discount_codes array
      if (data.discount_codes && data.discount_codes.find(function(discount) {
        return discount.code === discountCodeValue && discount.applicable === false;
      })) {
        discountCode.value = '';
        self.handleDiscountError('discount_code');
        return;
      }

      // Success - refresh the entire cart drawer
      discountCode.value = '';
      self.refreshCartDrawer();
    })
    .catch(function(error) {
      console.error('Discount application error:', error);
      // Show generic error
      self.handleDiscountError('discount_code');
    })
    .finally(function() {
      self.activeFetch = null;
    });
  };

  CartDiscountComponent.prototype.refreshCartDrawer = function() {
    var self = this;
    // Get the updated cart drawer HTML
    fetch('?section_id=cart-drawer')
    .then(function(response) {
      return response.text();
    })
    .then(function(responseText) {
      var html = responseText;
      var parsedState = {
        items: [],
        sections: { 'cart-drawer': html }
      };

      // Get the cart drawer element and update it
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.renderContents) {
        cartDrawer.renderContents(parsedState);
        
        // After rendering, rebind events to the new cart discount component
        setTimeout(function() {
          var newCartDiscountComponent = cartDrawer.querySelector('cart-discount-component');
          if (newCartDiscountComponent) {
            newCartDiscountComponent.setupRefs();
            newCartDiscountComponent.bindEvents();
          }
        }, 100);
      }
    })
    .catch(function(error) {
      console.error('Error refreshing cart drawer:', error);
    });
  };

  CartDiscountComponent.prototype.removeDiscount = function(event) {
    var self = this;
    event.preventDefault();
    event.stopPropagation();

    if ((event instanceof KeyboardEvent && event.key !== 'Enter') ||
        !(event instanceof MouseEvent) ||
        !(event.target instanceof HTMLElement) ||
        typeof this.dataset.sectionId !== 'string') {
      return;
    }

    var pill = event.target.closest('.cart-discount__pill');
    if (!(pill instanceof HTMLLIElement)) return;

    var discountCode = pill.dataset.discountCode;
    if (!discountCode) return;

    var existingDiscounts = this.existingDiscounts();
    var index = existingDiscounts.indexOf(discountCode);
    if (index === -1) return;

    existingDiscounts.splice(index, 1);

    var abortController = this.createAbortController();
    var cartUpdateUrl = this.getCartUpdateUrl();

    var discountData = {
      discount: existingDiscounts.join(',')
    };

    fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(discountData),
      signal: abortController.signal
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(function(data) {
      // Refresh the entire cart drawer
      self.refreshCartDrawer();
    })
    .catch(function(error) {
      console.error('Discount removal error:', error);
    })
    .finally(function() {
      self.activeFetch = null;
    });
  };

  CartDiscountComponent.prototype.handleDiscountError = function(type) {
    var cartDiscountError = this.refs.cartDiscountError;
    var cartDiscountErrorDiscountCode = this.refs.cartDiscountErrorDiscountCode;
    var cartDiscountErrorShipping = this.refs.cartDiscountErrorShipping;
    
    if (cartDiscountError) {
      cartDiscountError.classList.remove('hidden');
    }
    
    if (type === 'discount_code' && cartDiscountErrorDiscountCode) {
      cartDiscountErrorDiscountCode.classList.remove('hidden');
    } else if (type === 'shipping' && cartDiscountErrorShipping) {
      cartDiscountErrorShipping.classList.remove('hidden');
    }
  };

  CartDiscountComponent.prototype.hideAllErrors = function() {
    var cartDiscountError = this.refs.cartDiscountError;
    var cartDiscountErrorDiscountCode = this.refs.cartDiscountErrorDiscountCode;
    var cartDiscountErrorShipping = this.refs.cartDiscountErrorShipping;
    
    if (cartDiscountError) {
      cartDiscountError.classList.add('hidden');
    }
    if (cartDiscountErrorDiscountCode) {
      cartDiscountErrorDiscountCode.classList.add('hidden');
    }
    if (cartDiscountErrorShipping) {
      cartDiscountErrorShipping.classList.add('hidden');
    }
  };

  CartDiscountComponent.prototype.existingDiscounts = function() {
    var discountCodes = [];
    var discountPills = this.querySelectorAll('.cart-discount__pill');
    
    for (var i = 0; i < discountPills.length; i++) {
      var pill = discountPills[i];
      if (pill instanceof HTMLLIElement && typeof pill.dataset.discountCode === 'string') {
        discountCodes.push(pill.dataset.discountCode);
      }
    }

    return discountCodes;
  };

  // Custom element definition
  if (!customElements.get('cart-discount-component')) {
    customElements.define('cart-discount-component', CartDiscountComponent);
  }
})();
